import { render, staticRenderFns } from "./index_oferta.vue?vue&type=template&id=4c27f0f8&scoped=true"
import script from "./index_oferta.vue?vue&type=script&lang=js"
export * from "./index_oferta.vue?vue&type=script&lang=js"
import style0 from "./index_oferta.vue?vue&type=style&index=0&id=4c27f0f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c27f0f8",
  null
  
)

export default component.exports